import "./assets/scss/argon-dashboard.scss";

export default {
  install() {},
};
